import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_SOCIAL_CONFIG_BEGIN, fetchSocialConfigSuccess, logError } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function fetchSocialConfig(action$, state$) {
    return action$.pipe(ofType(FETCH_SOCIAL_CONFIG_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.getTweetConfig()).pipe(switchMap(function(socialConfig) {
            var actions = [
                fetchSocialConfigSuccess({
                    socialConfig: socialConfig
                })
            ];
            // fetch users and groups upon successfull login (fetchSocialConfig is called after user login was successful) if:
            // there is a disclaimer that has already been endorsed
            // there is no disclaimer
            // console.log('***** socialConfig', socialConfig);
            // console.log('***** session', state$.value.session);
            // if (
            //   (socialConfig.disclaimer.needs_endorsement &&
            //     state$.value.session?.is_disclaimer_endorsed) ||
            //   !socialConfig.disclaimer.needs_endorsement
            // ) {
            //   actions.push(fetchGroups(), fetchUsers());
            // }
            return actions;
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_social_config"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_social_config"
        }));
    }));
}
